import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import TransactionAPI from "../../../../../apiConfig/TransactionsAPI";

export const status = {
  INITIAL: "INITIAL",
  LOADING: "LOADING",
  LOADED: "LOADED",
  EMPTY: "EMPTY",
  ERROR: "ERROR",
};

const initialState = {
  detail: null,
  status: status.INITIAL,
  errorMessage: null,
};

export const fetchTransactionDetail = createAsyncThunk(
  "transaction/fetchTransactionDetail",
  async ({ transactionHash }, { rejectWithValue }) => {
    try {
      const response = await TransactionAPI.get(
        `/transactions/${transactionHash}`,
      );
      return {
        status: response.status,
        data: response.data[0] || null,
      };
    } catch (err) {
      if (err.response) {
        return rejectWithValue({
          status: err.response.status,
          data: err.response.data,
        });
      }
      return rejectWithValue({
        status: "",
        data: err.message,
      });
    }
  },
);

const TransactionDetailSlice = createSlice({
  name: "transactionDetail",
  initialState,
  reducers: {
    resetTransactionDetail: (state, action) => {
      state.detail = null;
      state.status = status.INITIAL;
      state.errorMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchTransactionDetail.pending, state => {
        state.errorMessage = null;
        state.status = status.LOADING;
      })
      .addCase(fetchTransactionDetail.fulfilled, (state, { payload }) => {
        state.detail = payload.data;
        state.errorMessage = null;
        state.status = status.LOADED;
      })
      .addCase(fetchTransactionDetail.rejected, (state, { payload }) => {
        if (payload === undefined) {
          state.status = status.ERROR;
          return;
        }
        state.errorMessage = payload.data;
        state.status = status.ERROR;
      });
  },
});

export const { resetTransactionDetail } = TransactionDetailSlice.actions;

export default TransactionDetailSlice.reducer;
